// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  height: 91vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  padding-top: 150px;
}
.hero .hero-background-image {
  position: absolute;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  object-fit: cover;
  z-index: 0;
  transition: transform 0.1s linear;
  will-change: transform;
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(7, 33, 70, 0.7) 0%, rgba(7, 33, 70, 0.6) 100%);
  z-index: 1;
}
.hero .container {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.hero .hero-content {
  margin: 0 auto;
  text-align: center;
  margin-top: auto;
  max-width: 840px;
}
.hero .hero-content h1 {
  color: #fff;
  font-size: 56px;
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 40px;
  line-height: 1.5;
}
@media (max-width: 1023px) {
  .hero .hero-content h1 {
    font-size: 36px !important;
    line-height: 1.2;
  }
}
.hero .scroll-down {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  z-index: 2;
  margin-bottom: 50px;
  margin-top: auto;
  cursor: pointer;
  animation: bounce 2s infinite;
  text-decoration: none;
}
.hero .scroll-down span {
  font-size: 14px;
  letter-spacing: 4px;
  text-transform: uppercase;
  margin-top: 12px;
  font-weight: 600;
  color: #fff;
}
.hero .scroll-down .scroll-icon {
  width: 20px;
  height: 32px;
}
.hero .scroll-down .scroll-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  animation: pulse 2s infinite;
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/hero/Hero.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAGI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,iCAAA;EACA,sBAAA;AADR;AAII;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uFAAA;EACA,UAAA;AAFR;AAKI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAHR;AAMI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAJR;AAMQ;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAJZ;AAOQ;EACI;IACI,0BAAA;IACA,gBAAA;EALd;AACF;AASI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,qBAAA;AAPR;AASQ;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAPZ;AAUQ;EACI,WAAA;EACA,YAAA;AARZ;AASY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AAPhB;AAYI;EACI;IACI,wBAAA;EAVV;EAYM;IACI,4BAAA;EAVV;EAYM;IACI,2BAAA;EAVV;AACF;AAaI;EACI;IACI,mBAAA;IACA,UAAA;EAXV;EAaM;IACI,qBAAA;IACA,YAAA;EAXV;EAaM;IACI,mBAAA;IACA,UAAA;EAXV;AACF","sourcesContent":[".hero {\n    height: 91vh;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    overflow: hidden;\n    padding-top: 150px;\n\n    \n\n    .hero-background-image {\n        position: absolute;\n        top: -10%;\n        left: -10%;\n        width: 120%;\n        height: 120%;\n        object-fit: cover;\n        z-index: 0;\n        transition: transform 0.1s linear;\n        will-change: transform;\n    }\n\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(180deg, rgba(7, 33, 70, 0.7) 0%, rgba(7, 33, 70, 0.6) 100%);\n        z-index: 1;\n    }\n\n    .container {\n        position: relative;\n        z-index: 2;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: center;\n        height: 100%;\n    }\n    \n    .hero-content {\n        margin: 0 auto;\n        text-align: center;\n        margin-top: auto;\n        max-width: 840px;\n        \n        h1 {\n            color: #fff;\n            font-size: 56px;\n            font-weight: 400;\n            line-height: 1.2;\n            margin-bottom: 40px;\n            line-height: 1.5;\n        }\n\n        @media (max-width: 1023px) {\n            h1 {\n                font-size: 36px !important;\n                line-height: 1.2;\n            }\n        }\n    }\n    \n    .scroll-down {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        color: #fff;\n        z-index: 2;\n        margin-bottom: 50px;\n        margin-top: auto;\n        cursor: pointer;\n        animation: bounce 2s infinite;\n        text-decoration: none;\n        \n        span {\n            font-size: 14px;\n            letter-spacing: 4px;\n            text-transform: uppercase;\n            margin-top: 12px;\n            font-weight: 600;\n            color: #fff;\n        }\n        \n        .scroll-icon {\n            width: 20px;\n            height: 32px;\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n                animation: pulse 2s infinite;\n            }\n        }\n    }\n    \n    @keyframes bounce {\n        0%, 20%, 50%, 80%, 100% {\n            transform: translateY(0);\n        }\n        40% {\n            transform: translateY(-10px);\n        }\n        60% {\n            transform: translateY(-5px);\n        }\n    }\n    \n    @keyframes pulse {\n        0% {\n            transform: scale(1);\n            opacity: 1;\n        }\n        50% {\n            transform: scale(1.1);\n            opacity: 0.8;\n        }\n        100% {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
